import { useState, useLayoutEffect, useRef } from 'react';

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var makeStore = function makeStore(initialState) {
  var state = initialState;
  var listeners = new Set();

  var getActualChanges = function getActualChanges(updates) {
    return Object.keys(updates).reduce(function (changes, prop) {
      if (updates[prop] !== state[prop]) changes[prop] = updates[prop];
      return changes;
    }, {});
  };

  return {
    get state() {
      return state;
    },

    set: function set(incoming) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$forceNotify = _ref.forceNotify,
          forceNotify = _ref$forceNotify === void 0 ? false : _ref$forceNotify;

      var incomingState = incoming instanceof Function ? incoming(state) : incoming;
      var updates = forceNotify ? incomingState : getActualChanges(incomingState);

      if (Object.keys(updates).length > 0) {
        var previousState = state;
        state = _objectSpread2(_objectSpread2({}, state), updates);

        var _iterator = _createForOfIteratorHelper(listeners),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _listener = _step.value;

            _listener(updates, previousState);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return state;
    },
    subscribe: function subscribe(listener) {
      listeners.add(listener);
    },
    unsubscribe: function unsubscribe(listener) {
      listeners["delete"](listener);
    }
  };
};
var useStore = function useStore(store) {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2);
      _useState2[0];
      var setVersion = _useState2[1];

  var subscribedProps = useConst(function () {
    return new Set();
  });
  var initialState = useConst(function () {
    return store.state;
  });
  useLayoutEffect(function () {
    if (store.state === initialState) return;
    subscribedProps.forEach(function (prop) {
      if (initialState[prop] !== store.state[prop]) {
        setVersion(function (v) {
          return v + 1;
        });
        return;
      }
    });
  }, [store]);
  useLayoutEffect(function () {
    var listener = function listener(updates) {
      if (Object.keys(updates).find(function (prop) {
        return subscribedProps.has(prop);
      })) {
        setVersion(function (v) {
          return v + 1;
        });
      }
    };

    store.subscribe(listener);
    return function () {
      return void store.unsubscribe(listener);
    };
  }, [store]);
  return new Proxy({}, {
    get: function get(_, prop) {
      subscribedProps.add(prop);
      return store.state[prop];
    }
  });
};

var useConst = function useConst(ctor) {
  var ref = useRef(null);
  if (!ref.current) ref.current = ctor();
  return ref.current;
};

export { makeStore, useStore };
